import $ from 'jquery'
import '../assets/global/scripts/bootstrap-maxlength/bootstrap-maxlength'

export default {
  // bind 时 父元素还不存在
  inserted(el, binding, vnode) {
    const $el = $(el)
    let config = binding.expression || {}

    config = $.extend(
      true,
      {
        alwaysShow: true,
        showOnReady: true,
        allowOverMax: false,
        appendToParent: true,
        // utf8: true,
        placement: 'centered-right'
      },
      config
    )

    setTimeout(function() {
      $el.maxlength(config)
    }, 1000)
  }
}
